import { IUserGroup } from '@boldpenguin/sdk';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const UserGroupsActions = createActionGroup({
  source: 'User Groups',
  events: {
    'Load User Groups': emptyProps(),
    'Load User Groups Success': props<{ groups: IUserGroup[] }>(),
    'Load User Groups Error': props<{ error: string }>(),
  },
});
